{
  "ranges": [
    {
      "id": "twin-hall-south",
      "u0": 4.1,
      "u1": 11.2,
      "v0": 6.3,
      "v1": 12.5,
      "alongU": true,
      "eaves": 9.6,
      "ridge": 13.4,
      "floors": 3
    },
    {
      "id": "twin-hall-north",
      "u0": 4.1,
      "u1": 11.2,
      "v0": 12.5,
      "v1": 18.7,
      "alongU": true,
      "eaves": 9.6,
      "ridge": 13.4,
      "floors": 3
    },
    {
      "id": "rear-range",
      "u0": 6.3,
      "u1": 13.7,
      "v0": 18.7,
      "v1": 35,
      "alongU": false,
      "eaves": 6.2,
      "ridge": 9.9,
      "floors": 2
    },
    {
      "id": "cross-range",
      "u0": -18.3,
      "u1": 14.5,
      "v0": 35,
      "v1": 40.5,
      "alongU": true,
      "eaves": 4.2,
      "ridge": 7.2,
      "floors": 1
    },
    {
      "id": "front-range-south",
      "u0": -18.3,
      "u1": -11.6,
      "v0": 6.3,
      "v1": 20.6,
      "alongU": false,
      "eaves": 3.2,
      "ridge": 5.1,
      "floors": 1
    },
    {
      "id": "front-range-north",
      "u0": -18.3,
      "u1": -11.6,
      "v0": 23.4,
      "v1": 35,
      "alongU": false,
      "eaves": 3.2,
      "ridge": 5.1,
      "floors": 1
    }
  ],
  "court": { "u0": -11.5, "u1": 4, "v0": 6.3, "v1": 34.9 },
  "frontDormers": [9.5, 16.5, 26.5, 32],
  "entry": { "u0": -18.3, "u1": -11.6, "v0": 20.6, "v1": 23.4 }
}
